import { StorageLocalBase } from "./StorageBase";

class StorageAuthImpl extends StorageLocalBase {
  StorageNamespace = "auth";

  readonly TokenType = "Bearer";

  private readonly KeyAccessToken: string = "accessToken";
  private readonly KeyEmail: string = "email";
  private readonly KeyUserName: string = "userName";
  private readonly KeyRole: string = "role";
  private readonly KeyCompanyId: string = "companyId";
  private readonly KeyCompanyName: string = "companyName";
  private readonly KeyFirstName: string = "firstName";
  private readonly KeyLastName: string = "lastName";
  private readonly KeyProfilePic: string = "profilePic";
  private readonly KeyIsAutoClockInEnable: string = "isAutoClockInEnable";

  get AccessToken(): string | undefined {
    return this.getString(this.KeyAccessToken);
  }

  set AccessToken(token: string | undefined) {
    this.setString(this.KeyAccessToken, token);
  }

  get AuthHeaderValue(): string | undefined {
    const headerVal = this.getString(this.KeyAccessToken);
    return headerVal ? this.TokenType + " " + headerVal : undefined;
  }

  get Email(): string | undefined {
    return this.getString(this.KeyEmail);
  }

  set Email(token: string | undefined) {
    this.setString(this.KeyEmail, token);
  }

  get UserName(): string | undefined {
    return this.getString(this.KeyUserName);
  }

  set UserName(token: string | undefined) {
    this.setString(this.KeyUserName, token);
  }

  get Role(): string | undefined {
    return this.getString(this.KeyRole);
  }

  set Role(token: string | undefined) {
    this.setString(this.KeyRole, token);
  }

  get CompanyId(): string | undefined {
    return this.getString(this.KeyCompanyId);
  }

  set CompanyId(token: string | undefined) {
    this.setString(this.KeyCompanyId, token);
  }

  get CompanyName(): string | undefined {
    return this.getString(this.KeyCompanyName);
  }

  set CompanyName(token: string | undefined) {
    this.setString(this.KeyCompanyName, token);
  }
  get FirstName(): string | undefined {
    return this.getString(this.KeyFirstName);
  }

  set FirstName(token: string | undefined) {
    this.setString(this.KeyFirstName, token);
  }
  get LastName(): string | undefined {
    return this.getString(this.KeyLastName);
  }

  set LastName(token: string | undefined) {
    this.setString(this.KeyLastName, token);
  }

  get ProfilePic(): string | undefined {
    return this.getString(this.KeyProfilePic);
  }

  set ProfilePic(token: string | undefined) {
    this.setString(this.KeyProfilePic, token);
  }

  get IsAutoClockInEnable(): boolean | undefined {
    return this.getBoolean(this.KeyIsAutoClockInEnable);
  }
  set IsAutoClockInEnable(isAutoClockInEnable: boolean | undefined) {
    this.setBoolean(this.KeyIsAutoClockInEnable, isAutoClockInEnable);
  }

  Clear(): void {
    [
      this.KeyAccessToken,
      this.KeyEmail,
      this.KeyUserName,
      this.KeyRole,
      this.KeyCompanyId,
      this.KeyCompanyName,
      this.KeyProfilePic,
      this.KeyFirstName,
      this.KeyLastName,
      this.KeyIsAutoClockInEnable,
    ].forEach((key) => {
      this.delete(key);
    });
  }
}

export const StorageAuth = new StorageAuthImpl();
